export default __webpack_public_path__ + "static/media/jj3_bg.0509deb9.png";